import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function ElectricitePage() {
  return <ServicePage data={servicesData.electricite} />;
}
